(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/pnp-step-indicator/react/pnp-step-indicator.js') >= 0) return;  svs.modules.push('/components/lb-ui/pnp-step-indicator/react/pnp-step-indicator.js');

'use strict';

const {
  StepIndicator,
  Step
} = svs.ui.ReactStepIndicator;

const PnpStepIndicator = _ref => {
  var _svs$core$config$data;
  let {
    isActiveHidden = false,
    twoStepVariant = false,
    step = 1,
    page = ''
  } = _ref;
  const isMomang = ((_svs$core$config$data = svs.core.config.data) === null || _svs$core$config$data === void 0 || (_svs$core$config$data = _svs$core$config$data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.site) === 'momang';
  if (!isMomang) {
    return null;
  }
  if (isNaN(step) || step < 1 || step > 3) {
    step = 1;
  }
  const twoStepLabelContent = page === 'deposit' ? 'Sätt in' : 'Gränser';
  return React.createElement(StepIndicator, {
    block: true,
    branding: "pnp-casino",
    className: twoStepVariant ? "js-step-indicator-pnp-casino two-step-indicator-".concat(page) : 'js-step-indicator-pnp-casino',
    showDone: true
  }, React.createElement("div", {
    className: "step-indicator-step-label-wrapper"
  }, React.createElement(Step, {
    isDone: step > 1,
    isSelected: step === 1 && !isActiveHidden,
    name: "one"
  }, "1"), React.createElement("div", {
    className: "step-indicator-pnp-label"
  }, "Verifiering")), React.createElement(React.Fragment, null, React.createElement("div", {
    className: "step-indicator-step-label-wrapper"
  }, React.createElement(Step, {
    isDone: step > 2,
    isSelected: step === 2 && !isActiveHidden,
    name: "two"
  }, "2"), React.createElement("div", {
    className: "step-indicator-pnp-label"
  }, twoStepVariant ? twoStepLabelContent : 'Gränser')), !twoStepVariant && React.createElement("div", {
    className: "step-indicator-step-label-wrapper"
  }, React.createElement(Step, {
    isSelected: step === 3 && !isActiveHidden,
    name: "three"
  }, "3"), React.createElement("div", {
    className: "step-indicator-pnp-label"
  }, "S\xE4tt in"))));
};
svs.components.lb_ui.pnpStepIndicator.PnpStepIndicator = PnpStepIndicator;

 })(window);